import { PAYMENTS } from '@routes/path'
import { Button, Layout, Spacer } from '@ui-kit'

import { useCheckoutContext } from '../contexts'
import { Header } from './components/Header'
import { PlanPanels } from './components/PlanPanels'

export const Plans = () => {
  const { goToStep } = useCheckoutContext()

  const handleClick = () => {
    goToStep(PAYMENTS.CHECKOUT.CONFIGURE)
  }

  return (
    <Layout width={1200}>
      <Header />

      <Spacer space={40} />

      {/* //TODO - delete this */}
      <span>
        <Button onClick={handleClick}>Next route</Button>
      </span>

      <PlanPanels />
    </Layout>
  )
}

Plans.displayName = 'CheckoutPlans'
